<h2 mat-dialog-title>Product Details</h2>

<mat-dialog-content>
    <!-- Input Form Inside Modal -->
    <form [formGroup]="productGroupForm">
        <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" placeholder="Enter name" formControlName="name">
        </div>
        <div class="mb-3">
            <label for="accountCode" class="form-label">Account Code</label>
            <input type="text" class="form-control" id="accountCode" placeholder="Enter account code"
                formControlName="accountCode">
        </div>
        <div class="mb-3">
            <label for="hsnCode" class="form-label">HSN Code</label>
            <input type="text" class="form-control" id="hsnCode" placeholder="Enter HSN code" formControlName="hsnCode">
        </div>
        <div class="mb-3">
            <label for="unitId" class="form-label">Unit</label>

            <select class="form-control dropdown_box" formControlName='unitId'>
                <option *ngFor="let unit of product_units" [value]="unit['id']">{{unit['name']}} </option>
            </select>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="warn">Cancel</button>
    <button mat-button [mat-dialog-close]="true" color="accent" (click)="saveprodugroup()">Save</button>
</mat-dialog-actions>